/** Skimmed energy-result heatmap (zeros removed, every 4th awake sample). Times are HH:mm. */
export const energySummaryMockHeatmap: { time: string; value: number }[] = [
  {
    time: '08:00',
    value: 0.0863,
  },
  {
    time: '08:04',
    value: 0.088,
  },
  {
    time: '08:08',
    value: 0.0903,
  },
  {
    time: '08:12',
    value: 0.0933,
  },
  {
    time: '08:16',
    value: 0.097,
  },
  {
    time: '08:20',
    value: 0.1015,
  },
  {
    time: '08:24',
    value: 0.1069,
  },
  {
    time: '08:28',
    value: 0.1132,
  },
  {
    time: '08:32',
    value: 0.1205,
  },
  {
    time: '08:36',
    value: 0.1287,
  },
  {
    time: '08:40',
    value: 0.1378,
  },
  {
    time: '08:44',
    value: 0.1478,
  },
  {
    time: '08:48',
    value: 0.1587,
  },
  {
    time: '08:52',
    value: 0.1703,
  },
  {
    time: '08:56',
    value: 0.1828,
  },
  {
    time: '09:00',
    value: 0.196,
  },
  {
    time: '09:04',
    value: 0.2099,
  },
  {
    time: '09:08',
    value: 0.2245,
  },
  {
    time: '09:12',
    value: 0.2398,
  },
  {
    time: '09:16',
    value: 0.2557,
  },
  {
    time: '09:20',
    value: 0.2721,
  },
  {
    time: '09:24',
    value: 0.289,
  },
  {
    time: '09:28',
    value: 0.3064,
  },
  {
    time: '09:32',
    value: 0.3242,
  },
  {
    time: '09:36',
    value: 0.3424,
  },
  {
    time: '09:40',
    value: 0.3609,
  },
  {
    time: '09:44',
    value: 0.3797,
  },
  {
    time: '09:48',
    value: 0.3986,
  },
  {
    time: '09:52',
    value: 0.4178,
  },
  {
    time: '09:56',
    value: 0.437,
  },
  {
    time: '10:00',
    value: 0.4564,
  },
  {
    time: '10:04',
    value: 0.4757,
  },
  {
    time: '10:08',
    value: 0.495,
  },
  {
    time: '10:12',
    value: 0.5142,
  },
  {
    time: '10:16',
    value: 0.5332,
  },
  {
    time: '10:20',
    value: 0.552,
  },
  {
    time: '10:24',
    value: 0.5706,
  },
  {
    time: '10:28',
    value: 0.5888,
  },
  {
    time: '10:32',
    value: 0.6067,
  },
  {
    time: '10:36',
    value: 0.6242,
  },
  {
    time: '10:40',
    value: 0.6413,
  },
  {
    time: '10:44',
    value: 0.6578,
  },
  {
    time: '10:48',
    value: 0.6738,
  },
  {
    time: '10:52',
    value: 0.6892,
  },
  {
    time: '10:56',
    value: 0.7037,
  },
  {
    time: '11:00',
    value: 0.7174,
  },
  {
    time: '11:04',
    value: 0.7301,
  },
  {
    time: '11:08',
    value: 0.7419,
  },
  {
    time: '11:12',
    value: 0.7527,
  },
  {
    time: '11:16',
    value: 0.7624,
  },
  {
    time: '11:20',
    value: 0.771,
  },
  {
    time: '11:24',
    value: 0.7786,
  },
  {
    time: '11:28',
    value: 0.785,
  },
  {
    time: '11:32',
    value: 0.7903,
  },
  {
    time: '11:36',
    value: 0.7944,
  },
  {
    time: '11:40',
    value: 0.7974,
  },
  {
    time: '11:44',
    value: 0.7994,
  },
  {
    time: '11:48',
    value: 0.8004,
  },
  {
    time: '11:52',
    value: 0.8004,
  },
  {
    time: '11:56',
    value: 0.7994,
  },
  {
    time: '12:00',
    value: 0.7975,
  },
  {
    time: '12:04',
    value: 0.7947,
  },
  {
    time: '12:08',
    value: 0.791,
  },
  {
    time: '12:12',
    value: 0.7864,
  },
  {
    time: '12:16',
    value: 0.7809,
  },
  {
    time: '12:20',
    value: 0.7746,
  },
  {
    time: '12:24',
    value: 0.7675,
  },
  {
    time: '12:28',
    value: 0.7596,
  },
  {
    time: '12:32',
    value: 0.751,
  },
  {
    time: '12:36',
    value: 0.7417,
  },
  {
    time: '12:40',
    value: 0.7318,
  },
  {
    time: '12:44',
    value: 0.7212,
  },
  {
    time: '12:48',
    value: 0.7101,
  },
  {
    time: '12:52',
    value: 0.6984,
  },
  {
    time: '12:56',
    value: 0.6863,
  },
  {
    time: '13:00',
    value: 0.6737,
  },
  {
    time: '13:04',
    value: 0.6607,
  },
  {
    time: '13:08',
    value: 0.6473,
  },
  {
    time: '13:12',
    value: 0.6336,
  },
  {
    time: '13:16',
    value: 0.6197,
  },
  {
    time: '13:20',
    value: 0.6056,
  },
  {
    time: '13:24',
    value: 0.5912,
  },
  {
    time: '13:28',
    value: 0.5768,
  },
  {
    time: '13:32',
    value: 0.5623,
  },
  {
    time: '13:36',
    value: 0.5477,
  },
  {
    time: '13:40',
    value: 0.5332,
  },
  {
    time: '13:44',
    value: 0.5187,
  },
  {
    time: '13:48',
    value: 0.5043,
  },
  {
    time: '13:52',
    value: 0.49,
  },
  {
    time: '13:56',
    value: 0.476,
  },
  {
    time: '14:00',
    value: 0.4621,
  },
  {
    time: '14:04',
    value: 0.4485,
  },
  {
    time: '14:08',
    value: 0.4352,
  },
  {
    time: '14:12',
    value: 0.4223,
  },
  {
    time: '14:16',
    value: 0.4097,
  },
  {
    time: '14:20',
    value: 0.3975,
  },
  {
    time: '14:24',
    value: 0.3857,
  },
  {
    time: '14:28',
    value: 0.3744,
  },
  {
    time: '14:32',
    value: 0.3635,
  },
  {
    time: '14:36',
    value: 0.3532,
  },
  {
    time: '14:40',
    value: 0.3434,
  },
  {
    time: '14:44',
    value: 0.3342,
  },
  {
    time: '14:48',
    value: 0.3255,
  },
  {
    time: '14:52',
    value: 0.3174,
  },
  {
    time: '14:56',
    value: 0.3099,
  },
  {
    time: '15:00',
    value: 0.303,
  },
  {
    time: '15:04',
    value: 0.2967,
  },
  {
    time: '15:08',
    value: 0.2911,
  },
  {
    time: '15:12',
    value: 0.2861,
  },
  {
    time: '15:16',
    value: 0.2817,
  },
  {
    time: '15:20',
    value: 0.2779,
  },
  {
    time: '15:24',
    value: 0.2748,
  },
  {
    time: '15:28',
    value: 0.2723,
  },
  {
    time: '15:32',
    value: 0.2704,
  },
  {
    time: '15:36',
    value: 0.2692,
  },
  {
    time: '15:40',
    value: 0.2684,
  },
  {
    time: '15:44',
    value: 0.2679,
  },
  {
    time: '15:48',
    value: 0.2676,
  },
  {
    time: '15:52',
    value: 0.2675,
  },
  {
    time: '15:56',
    value: 0.2676,
  },
  {
    time: '16:00',
    value: 0.268,
  },
  {
    time: '16:04',
    value: 0.2686,
  },
  {
    time: '16:08',
    value: 0.2694,
  },
  {
    time: '16:12',
    value: 0.2703,
  },
  {
    time: '16:16',
    value: 0.2715,
  },
  {
    time: '16:20',
    value: 0.2729,
  },
  {
    time: '16:24',
    value: 0.2745,
  },
  {
    time: '16:28',
    value: 0.2764,
  },
  {
    time: '16:32',
    value: 0.2789,
  },
  {
    time: '16:36',
    value: 0.282,
  },
  {
    time: '16:40',
    value: 0.2856,
  },
  {
    time: '16:44',
    value: 0.2897,
  },
  {
    time: '16:48',
    value: 0.2944,
  },
  {
    time: '16:52',
    value: 0.2997,
  },
  {
    time: '16:56',
    value: 0.3055,
  },
  {
    time: '17:00',
    value: 0.3118,
  },
  {
    time: '17:04',
    value: 0.3186,
  },
  {
    time: '17:08',
    value: 0.3259,
  },
  {
    time: '17:12',
    value: 0.3338,
  },
  {
    time: '17:16',
    value: 0.3421,
  },
  {
    time: '17:20',
    value: 0.3508,
  },
  {
    time: '17:24',
    value: 0.36,
  },
  {
    time: '17:28',
    value: 0.3696,
  },
  {
    time: '17:32',
    value: 0.3796,
  },
  {
    time: '17:36',
    value: 0.3899,
  },
  {
    time: '17:40',
    value: 0.4006,
  },
  {
    time: '17:44',
    value: 0.4116,
  },
  {
    time: '17:48',
    value: 0.4229,
  },
  {
    time: '17:52',
    value: 0.4345,
  },
  {
    time: '17:56',
    value: 0.4463,
  },
  {
    time: '18:00',
    value: 0.4582,
  },
  {
    time: '18:04',
    value: 0.4704,
  },
  {
    time: '18:08',
    value: 0.4826,
  },
  {
    time: '18:12',
    value: 0.495,
  },
  {
    time: '18:16',
    value: 0.5074,
  },
  {
    time: '18:20',
    value: 0.5199,
  },
  {
    time: '18:24',
    value: 0.5323,
  },
  {
    time: '18:28',
    value: 0.5447,
  },
  {
    time: '18:32',
    value: 0.557,
  },
  {
    time: '18:36',
    value: 0.5692,
  },
  {
    time: '18:40',
    value: 0.5812,
  },
  {
    time: '18:44',
    value: 0.593,
  },
  {
    time: '18:48',
    value: 0.6046,
  },
  {
    time: '18:52',
    value: 0.616,
  },
  {
    time: '18:56',
    value: 0.627,
  },
  {
    time: '19:00',
    value: 0.6377,
  },
  {
    time: '19:04',
    value: 0.648,
  },
  {
    time: '19:08',
    value: 0.6578,
  },
  {
    time: '19:12',
    value: 0.6673,
  },
  {
    time: '19:16',
    value: 0.6763,
  },
  {
    time: '19:20',
    value: 0.6847,
  },
  {
    time: '19:24',
    value: 0.6927,
  },
  {
    time: '19:28',
    value: 0.7,
  },
  {
    time: '19:32',
    value: 0.7068,
  },
  {
    time: '19:36',
    value: 0.7129,
  },
  {
    time: '19:40',
    value: 0.7184,
  },
  {
    time: '19:44',
    value: 0.723,
  },
  {
    time: '19:48',
    value: 0.7269,
  },
  {
    time: '19:52',
    value: 0.7299,
  },
  {
    time: '19:56',
    value: 0.732,
  },
  {
    time: '20:00',
    value: 0.7333,
  },
  {
    time: '20:04',
    value: 0.7337,
  },
  {
    time: '20:08',
    value: 0.7333,
  },
  {
    time: '20:12',
    value: 0.7319,
  },
  {
    time: '20:16',
    value: 0.7297,
  },
  {
    time: '20:20',
    value: 0.7266,
  },
  {
    time: '20:24',
    value: 0.7227,
  },
  {
    time: '20:28',
    value: 0.7179,
  },
  {
    time: '20:32',
    value: 0.7125,
  },
  {
    time: '20:36',
    value: 0.7063,
  },
  {
    time: '20:40',
    value: 0.6995,
  },
  {
    time: '20:44',
    value: 0.692,
  },
  {
    time: '20:48',
    value: 0.6839,
  },
  {
    time: '20:52',
    value: 0.6751,
  },
  {
    time: '20:56',
    value: 0.6658,
  },
  {
    time: '21:00',
    value: 0.6559,
  },
  {
    time: '21:04',
    value: 0.6454,
  },
  {
    time: '21:08',
    value: 0.6345,
  },
  {
    time: '21:12',
    value: 0.623,
  },
  {
    time: '21:16',
    value: 0.6111,
  },
  {
    time: '21:20',
    value: 0.5988,
  },
  {
    time: '21:24',
    value: 0.5861,
  },
  {
    time: '21:28',
    value: 0.5731,
  },
  {
    time: '21:32',
    value: 0.5597,
  },
  {
    time: '21:36',
    value: 0.5461,
  },
  {
    time: '21:40',
    value: 0.5322,
  },
  {
    time: '21:44',
    value: 0.5181,
  },
  {
    time: '21:48',
    value: 0.5039,
  },
  {
    time: '21:52',
    value: 0.4895,
  },
  {
    time: '21:56',
    value: 0.4751,
  },
  {
    time: '22:00',
    value: 0.4606,
  },
  {
    time: '22:04',
    value: 0.4461,
  },
  {
    time: '22:08',
    value: 0.4316,
  },
  {
    time: '22:12',
    value: 0.4173,
  },
  {
    time: '22:16',
    value: 0.403,
  },
  {
    time: '22:20',
    value: 0.3889,
  },
  {
    time: '22:24',
    value: 0.3749,
  },
  {
    time: '22:28',
    value: 0.3612,
  },
  {
    time: '22:32',
    value: 0.3478,
  },
  {
    time: '22:36',
    value: 0.3347,
  },
  {
    time: '22:40',
    value: 0.3219,
  },
  {
    time: '22:44',
    value: 0.3095,
  },
  {
    time: '22:48',
    value: 0.2975,
  },
  {
    time: '22:52',
    value: 0.2859,
  },
  {
    time: '22:56',
    value: 0.2748,
  },
  {
    time: '23:00',
    value: 0.2643,
  },
  {
    time: '23:04',
    value: 0.2542,
  },
  {
    time: '23:08',
    value: 0.2447,
  },
  {
    time: '23:12',
    value: 0.2358,
  },
  {
    time: '23:16',
    value: 0.2275,
  },
  {
    time: '23:20',
    value: 0.2199,
  },
  {
    time: '23:24',
    value: 0.2129,
  },
  {
    time: '23:28',
    value: 0.2065,
  },
  {
    time: '23:32',
    value: 0.2009,
  },
  {
    time: '23:36',
    value: 0.196,
  },
  {
    time: '23:40',
    value: 0.1918,
  },
  {
    time: '23:44',
    value: 0.1882,
  },
  {
    time: '23:48',
    value: 0.1853,
  },
  {
    time: '23:52',
    value: 0.183,
  },
  {
    time: '23:56',
    value: 0.1811,
  },
];
